module.exports = __webpack_public_path__ + "static/Profile_KlasNystrom-02124766a0c05661262579cf99552f00.jpg";